module.exports = __webpack_public_path__ + "img/LoginAssets.ad6c5e55.svg";